import Navigation from './navigation.js';
import CountDown from './CountDown.js';
import PanelsSlider from './PanelsSlider.js';
import JackpotsFilter from './JackpotsFilter.js';
import OddsCalc from './oddsCalc.js';
import LotteriesResultsSearch from './lotteriesResultsSearch.js';

//import lozad from 'lozad';

//const observer = lozad(); // lazy loads elements with default selector as '.lozad'
//observer.observe();

[ ... document.getElementsByClassName('panelsSlider') ].forEach((el)=>{

	let slider = new PanelsSlider(el);
});

Navigation();

let  oddsCalc = new OddsCalc();

window.jackpotsFilter = new JackpotsFilter ("filter");

let homeCountDown = new CountDown('homeLotteryCard-nextDrawing');

let  jackpotsCountDown = new CountDown('currentJackpots-nextDrawing-time');

let  generatorsCountDown = new CountDown('generator-nextDrawing-time');

let  lotteriesResultsSearch = new LotteriesResultsSearch();

let collapsible = document.querySelectorAll('.collapsible');

[].forEach.call(collapsible, function (el) {
	let title = el.querySelector('.collapsible-title');

	title.onclick = function(){
		
		el.classList.toggle('collapsed');
	}
});



let imagesToPreload = document.querySelectorAll('.preloadImage');

function preload(images, _index) {

        let index = _index || 0,
        img = images[index],
        initialSrc = img.src;

        if (images && images.length > index) {

     		img.src = img.dataset.src;

            img.onload = ()=>{
                preload(images, index + 1);
        	}

        	img.onerror = (e)=>{
        		img.onload=null;
        		img.src = initialSrc;
        		preload(images, index + 1);
        	}
   		}
        
}

if(imagesToPreload.length) {
	preload(imagesToPreload);	
}



function getLocation (clbck) {

	let  country = getCookie("lottery_critic_user_country");


	if(country == "") {
		fetch('https://get.geojs.io/v1/ip/country.json', {mode: 'cors'})
		  .then(response=>{
		    return response.json();
		  })
		  .then(json=> {
		   
		    setCookie("lottery_critic_user_country", json.country, 2);
		    country = json.country;
		    clbck(country);
		    
		});
	}else {
		clbck(country);
		
	}


	function setCookie(cname, cvalue, exdays) {
	    var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}


};






addEventListener("DOMContentLoaded", ()=>{

	getLocation(changeLinks);

	function changeLinks (userCountry) {

		GEO_LINKS.forEach ( ( linkObj ) => {

			let linkID = linkObj.useDefault ? linkObj.defaultURL : linkObj.linkID,
				links = document.querySelectorAll('a[href="'+linkID+'"]'),
				link = linkObj.defaultURL;

			linkObj.locations.forEach( location => {

				let countrycodes = location.countryCodes.split(',').map(item => {
					 return item.trim();
				});

				if( countrycodes.indexOf(userCountry)!=-1 ) {
					link = location.link;
				}
			});

			[].forEach.call(links, ( linkNode )=>{
				linkNode.href = link;

			});
		});
	}


});

/*[].forEach.call(imagesPreload, function (el) {

	//console.log(el.dataset.src);
	let src = el.src;
	//el.src = el.dataset.src;
	//el.onload = function() {

	//}
	el.onerror = function(e) {
		e.preventDefault();
		el.src = src;
	}
});*/


(function stickyHeader () {

	let scrolling = false,
	scrollTimeout = null,
	header  = document.querySelector('.header-fixed'),
	headerClasslist;

	if(header) {
		headerClasslist = document.querySelector('.header-fixed').classList;
	}else {
		return;
	}

	function scroll(){
		if(!scrolling){
		
			scrolling = true;
			scrollTimeout = setTimeout(() => {
				scrolling = false;
				headerClasslist.remove('header-fixed_sticky');
				if(window.scrollY < 1) {
					headerClasslist.remove('header-fixed_hover');
				}
			}, 500);


			if(window.scrollY > 0 && 
				!headerClasslist.contains('header-fixed_hover')) {

				headerClasslist.add('header-fixed_hover');
				//header.classList.add('header-fixed_sticky');
			}
			
		}
	}

		window.addEventListener('scroll', scroll.bind(this));
		scroll();
})();

function onPageNav () {
	let links = document.querySelectorAll('.stickyPageNav-link'),
	anchors = {},
	scrolling = false,
	scrollTimeout = null;

	if(!links.length){
		return;

	}

	[].forEach.call(links, (el)=>{
		let hash='#'+el.href.split("#")[1];
		anchors[hash] = el;
		el.onclick = ()=>{select(hash)};
	});
	
	function select(anchor) {
		[].forEach.call(links, (el)=>{
			el.classList.remove('stickyPageNav-link_active');
		});
		anchors[anchor].classList.add('stickyPageNav-link_active');
	}


	function scroll(){
		if(!scrolling){
			let currentAnchor = '#top'; 
			scrolling = true;
			scrollTimeout = setTimeout(() => {
				scrolling = false;
			}, 100);

			[].forEach.call(links, (link) => {
				
				let id = link.href.split('#')[1],
				linked = document.getElementById(id),
				bodyRect = document.body.getBoundingClientRect(),
				rect = linked.getBoundingClientRect();
				//console.log(rect.top - bodyRect.top < window.scrollY);
				if(rect.top - bodyRect.top -1 <  window.scrollY) {
					currentAnchor = '#' + id;
				}

			});
			
			select(currentAnchor);
		}
	}

	window.addEventListener('scroll', scroll.bind(this));


}

onPageNav();


// WEBPACK FOOTER //
// ./js/src/main.js